import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {AppRoutingModule} from '@app/app-routing.module';
import {AppComponent} from '@app/app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpMockRequestInterceptor} from '@global/http-mock-request-interceptor';
import {loadConfig} from '@services/infra/config.initializer';
import {ConfigService} from '@services/infra/config.service';
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {provideMomentDateAdapter, MomentDateAdapter} from '@angular/material-moment-adapter';
import {MarkantElementsModule} from '@markant/elements-angular';
import {CommonModule, registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import {LoggingService} from '@services/logging.service';
import {MatPaginatorIntlDe} from '@util/lang/mat-paginator-de';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {ImageCropperModule} from 'ngx-image-cropper';
import {ProductStateTranslate} from '@util/pipes/product-state-translate';
import {RouterModule} from '@angular/router';
import {VoilaUserService} from '@services/voila-user.service';
import {MesseUiToolkitModule, UserService} from '@common/messe-ui-toolkit';
import {environment} from '@environments/environment';
import {LoginRequiredDialogComponent} from '@app/login-required-dialog/login-required-dialog.component';
import {FooterComponent} from '@app/footer/footer.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(localeDe, localeDeExtra);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MarkantElementsModule.forRoot({
      locale: 'de-DE',
      currencyLocale: 'de-DE',
    }),
    MesseUiToolkitModule.forRoot({
      clientIdAuth0: environment.clientIdAuth0,
      identityProviderUrl: environment.identityProviderUrl,
      allowedBackendUrls: environment.allowedBackendUrls,
      externalCss: environment.externalCss,
    }),
    ImageCropperModule,
    MatSelectModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
    FormsModule,
    LoginRequiredDialogComponent,
    FooterComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpMockRequestInterceptor,
      multi: true,
    },
    {provide: APP_INITIALIZER, useFactory: loadConfig, deps: [ConfigService], multi: true},
    {provide: LOCALE_ID, useValue: 'de-DE'},
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: UserService, useClass: VoilaUserService},
    {provide: VoilaUserService, useExisting: UserService},
    {provide: MatPaginatorIntl, useClass: MatPaginatorIntlDe},
    LoggingService,
    ProductStateTranslate,
    provideHttpClient(withInterceptorsFromDi()),
    provideMomentDateAdapter(),
  ],
})
export class AppModule {}
